<template>
  <div class="page-XLpartners container-fluid mt-5" ref="box">
    <div class="box-padding">
      <div class="XLpartners-text animate__animated animate__slow" ref="title">
        <h1 class="title">合作伙伴</h1>
        <p class="title-en title"> Cooperation</p>
      </div>
      <div class="XLpartners-content">
        <div
          class="row animate__animated animate__slower"
          ref="XLpartners-content"
        >
          <div
            v-for="(item, index) in imgList"
            :key="index"
            class="mt-4 col-md-2 col-4"
          >
            <img
              :width="index + 1 === imgList.length ? '70%' : '70%'"
              :height="index + 1 === imgList.length ? '70%' : '70%'"
              style="object-fit: contain"
              :src="item.img"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "XLpartners",
  data() {
    return {
      titleShow: false,
      oldScrollTop: 0,
      imgList: [
        {
          img: require("@/components/XLpartners/style/img/picture1.png"),
        },
        {
          img: require("@/components/XLpartners/style/img/picture2.png"),
        },
        {
          img: require("@/components/XLpartners/style/img/picture3.png"),
        },
        {
          img: require("@/components/XLpartners/style/img/picture4.png"),
        },
        {
          img: require("@/components/XLpartners/style/img/picture5.png"),
        },
        {
          img: require("@/components/XLpartners/style/img/picture6.png"),
        },
        {
          img: require("@/components/XLpartners/style/img/picture7.png"),
        },
        {
          img: require("@/components/XLpartners/style/img/picture8.png"),
        },
        {
          img: require("@/components/XLpartners/style/img/picture9.png"),
        },
        {
          img: require("@/components/XLpartners/style/img/picture10.png"),
        },
        {
          img: require("@/components/XLpartners/style/img/picture11.png"),
        },
        {
          img: require("@/components/XLpartners/style/img/picture12.png"),
        },
        // {
        //   img: require("@/components/XLpartners/style/img/picture13.png"),
        // },
        {
          img: require("@/components/XLpartners/style/img/picture14.png"),
        },
        {
          img: require("@/components/XLpartners/style/img/picture15.png"),
        },
        {
          img: require("@/components/XLpartners/style/img/picture16.png"),
        },
        {
          img: require("@/components/XLpartners/style/img/picture17.png"),
        },
        {
          img: require("@/components/XLpartners/style/img/picture18.png"),
        },
        {
          img: require("@/components/XLpartners/style/img/picture19.png"),
        },
      ],
    };
  },
  methods: {
    handleScroll() {
      let _this = this;
      let refArray = [
        {
          ref: "title",
          height: 0,
          animate: "animate__slideInUp",
        },
        {
          ref: "XLpartners-content",
          height: 0,
          animate: "animate__fadeInLeft",
        },
      ];
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // 滚动条滚动的距离
      let scrollStep = scrollTop - this.oldScrollTop;
      // 更新——滚动前，滚动条距文档顶部的距离
      this.oldScrollTop = scrollTop;
      if (scrollStep < 0) {
        refArray.forEach((r) => {
          var a, c, d;
          a = this.$refs["box"].offsetTop;
          c = scrollTop; //  获取窗口滚动条高度
          d =
            document.documentElement.clientHeight || document.body.clientHeight; // 获取浏览器可视区的高度
          if (c + d < a) {
            this.$refs[r.ref].classList.remove(r.animate);
          }
        });
      } else {
        refArray.forEach((r) => {
          _this.$utils.gdjz(this.$refs[r.ref], r.height, r.animate, () => {
            window.requestAnimationFrame(function () {
              _this.$refs[r.ref].classList.add(r.animate);
            });
          });
        });
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="less" scoped>
.page-XLpartners {
  padding: 50px 0;
  margin-top: 8rem !important;
  .XLpartners-text {
    text-align: center;
    .title {
      font-size: 2rem;
      color: #fff;
    }
    .title-en {
      font-size: 1.2rem;
      color: #ffffff6e;
    }
  }
  .XLpartners-content {
    margin: 4rem 0;
    padding: 2% 13%;
    background-color: #fff;
  }
  // @media (max-width: 960px) {
  //   .XLpartners-content {
  //     height: 200px;
  //   }
  // }
}
</style>
